<template lang="pug">
.post-content__section.--image(
  :class="{ '--focus': inFocus }"
  :tabindex="canEdit ? 0 : false"
  @focus="onFocus"
  @blur="onBlur"
  @keyup.up="$emit('keyup', $event)"
  @keyup.down="$emit('keyup', $event)"
)
  .image__header(
    v-if="canRemove"
  )
    .remove-button.btn.--link(
      @click="$emit('remove')"
    ) Remove
  .img-wrapper(
    :style="imageStyles"
  )
    img(
      :src="src"
    )
    .img-overlay(v-if="blockInteraction")
  .image__footer
    span.image-caption {{ caption }}
    span.image-credit {{ credit }}
</template>

<script>
export default {
  name: 'image-section',
  props: {
    section: {
      type: Object,
      default: null,
    },
    canRemove: {
      type: Boolean,
      default: false,
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
    blockInteraction: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inFocus: false,
    }
  },
  computed: {
    caption() {
      const { caption = '' } = this.section
      return caption
    },
    src() {
      const { src = null } = this.section
      return src
    },
    credit() {
      const { creator, credit } = this.section
      return credit || creator || ''
    },
    imageStyles() {
      const { width = 0, height = 0 } = this.section
      return {
        paddingBottom: `calc((${height} / ${width}) * 100%`,
      }
    },
    // "copyrightNotice": "© Copyright 2020 IPTC (Test Images) - www.iptc.org",
    // "webStatementOfRights": "https://iptc.org/tests/copyright-and-licenses-of-images-test-page/",
  },
  methods: {
    focus() {
      this.$el.focus()
    },
    onFocus() {
      this.inFocus = true
    },
    onBlur() {
      this.inFOcus = false
    }
  },
}
</script>

<style lang="sass">
.image__header,
.image__footer
  padding: .5rem .75rem 
  display: flex
  align-items: center // vertical alignment
  justify-content: space-between

.img-wrapper
  position: relative
  width: 100%
  background-color: #aaa
  border: 1px solid var(--base-color)
  
  img
    position: absolute
    width: 100%;
    height: 100%;
    object-fit: cover

.img-overlay
  position: absolute
  top: 0px
  left: 0px
  bottom: 0px
  right: 0px
</style>
